import { createRoot } from 'react-dom/client'
import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { numberOfTrips } from '../actions/search-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
  itineraryPopupOpen,
  itineraryPopupData,
} from '../actions/main-actions'
import {
  currencyDirective,
  toggleDestinations,
  convertDjangoRenderedPrice,
  hideMobileAppPromotion,
} from '../directives'
import ErrorHandler from '../components/ErrorHandler'

// import * as fx from '../libs/money'
import { getLanguage, getTranslations } from 'utils'
import { toast } from 'react-toastify'
import 'babel-polyfill'
import 'whatwg-fetch'
import 'react-toastify/dist/ReactToastify.css'

import HeroSearch from '../components/homepage/Hero'
import HomepageCollections from '../components/homepage/HomepageCollections'
import SpecialDeals from '../components/homepage/SpecialDeals'
import IndividualBooking from '../components/footer/IndividualBooking'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import AdventuresNearby from '../components/homepage/AdventuresNearby'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

let store = createStore(
  combineReducers({
    pageLoader,
    numberOfTrips,
    selectedCurrency,
    itineraryPopupOpen,
    itineraryPopupData,
  })
)

let language = getLanguage()
let messages = {}
toast.configure()

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  // renderElement('homepage-previous-search', PreviousSearch)
  renderElement('contact-us-btn', IndividualBooking)
  renderElement('homepage-hero-search', HeroSearch, {
    searchLaUrl: window.searchLaUrl,
  })
  renderElement('homepage-collections', HomepageCollections)
  renderElement('homepage-special-deals', SpecialDeals, {
    eCommerceListName: 'Travel Homepage - Vacations - Exclusive Deals',
  })
  renderElement('email-us', IndividualBooking)
  renderElement('adventures-nearby', AdventuresNearby)
  toggleDestinations()
  hideMobileAppPromotion()
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  convertDjangoRenderedPrice(renderElement)
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>
    )
  }
}
